import { useState } from 'react'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Fade from '@mui/material/Fade'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import { MultilineTypography } from '../../../theme/components/MultilineTypography'
import { PropertyRow } from '../../../theme/components/PropertyRow'
import type { Aanvrager } from '../types/Aanvrager'
import type { Klantgegevens } from '../types/Klantgegevens'

const createAanvragerNaam = (aanvrager: Aanvrager) => {
  const { aanhef, achternaam, tussenvoegsels, voorletters } = aanvrager

  return `${aanhef} ${voorletters}${
    tussenvoegsels ? ` ${tussenvoegsels}` : ''
  } ${achternaam}`
}

interface Props {
  gegevens: Klantgegevens
}

export const Gegevens = ({ gegevens }: Props) => {
  const [expanded, setExpanded] = useState(true)

  const {
    aanvrager,
    contactPersoon,
    bedrijfsnaam,
    isProfessioneel,
    omschrijving,
    gerelateerdeAanvragen,
  } = gegevens
  const { emailadres, telefoonnummer, telefoonnummerMobiel } = aanvrager || {}
  const {
    naam,
    emailadres: contactEmailadres,
    telefoonnummerMobiel: contactTelefoonnummerMobiel,
  } = contactPersoon || {}

  if (!aanvrager) {
    return null
  }

  return (
    <>
      <Accordion
        defaultExpanded
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{ position: 'relative' }}
        >
          <Fade in={!expanded}>
            <Typography>Aanvrager & contactpersoon uitvoering</Typography>
          </Fade>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={6}>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
            >
              <Typography variant="h4" sx={{ color: 'black' }}>
                Aanvrager
              </Typography>

              <PropertyRow
                label="Naam"
                value={createAanvragerNaam(aanvrager)}
              />

              <PropertyRow label="E-mailadres" value={emailadres} />

              <PropertyRow
                label="Telefoonnummer (mobiel)"
                value={telefoonnummerMobiel}
              />
              <PropertyRow label="Telefoonnummer" value={telefoonnummer} />

              <PropertyRow label="Bedrijfsnaam" value={bedrijfsnaam} />

              <PropertyRow
                label="Professionele klant"
                value={isProfessioneel ? 'Ja' : 'Nee'}
              />

              <PropertyRow
                label="Opmerking"
                value={
                  omschrijving ? (
                    <MultilineTypography text={omschrijving} />
                  ) : undefined
                }
              />

              <PropertyRow
                label="Gerelateerde aanvragen"
                value={gerelateerdeAanvragen?.join(', ')}
              />
            </Grid>

            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
            >
              <Typography variant="h4" sx={{ color: 'black' }}>
                Contactpersoon uitvoering
              </Typography>
              <PropertyRow label="Naam" value={naam} />
              <PropertyRow label="E-mailadres" value={contactEmailadres} />
              <PropertyRow
                label="Telefoonnummer (mobiel)"
                value={contactTelefoonnummerMobiel}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  )
}
